<template>
  <div class="container">
    <div class="banner">
      <p class="title">{{title}}</p>
      <p class="desc">{{desc}}</p>
    </div>

    <div class="bank-info">
      <div class="link-tip" @click="goLink">
        {{input_title}}
        <span class="info-arrow"></span>
      </div>
      <div>
        <ul v-if="defaultPayMethod.bankInfo">
          <li>
            <span class="left">Nome</span>
            <span
              class="right"
            >{{bankInfo.citi_para.holder_first_name}} {{bankInfo.citi_para.holder_last_name}}</span>
          </li>
          <li>
            <span class="left">CPF</span>
            <span class="right">{{bankInfo.cpf}}</span>
          </li>
          <li>
            <span class="left">Banco</span>
            <span class="right">{{bankInfo.citi_para.bank_name}}</span>
          </li>
          <li>
            <span class="left">Agência</span>
            <span class="right">{{bankInfo.external_account.routing_number}}</span>
            <span class="digit">
              Dígito
              <span class="right">{{bankInfo.citi_para.agency_digit || '-'}}</span>
            </span>
          </li>
          <li>
            <span class="left">Conta</span>
            <span class="right">{{bankInfo.external_account.account_number}}</span>
            <span class="digit">
              Dígito
              <span class="right">{{bankInfo.citi_para.account_digit || '-'}}</span>
            </span>
          </li>
          <li>
            <span class="left">Tipo</span>
            <span
              class="right"
            >{{bankInfo.citi_para.card_type==1?"Conta corrente":"Conta poupança"}}</span>
          </li>
        </ul>
        <ul class="address-info" v-else-if="payment99CardAddress">
          <li>
            <div class="label">Endereço</div>
            <div class="txt">{{payment99CardAddress}}</div>
          </li>
          <li>
            <div class="label">CEP</div>
            <div class="txt">{{address.zipCode}}</div>
          </li>
        </ul>
        <p
          class="status-tip tip_4"
          v-if="defaultPayMethod.address"
        >O seu Cartão 99 será enviado para este endereço</p>
      </div>
    </div>
  </div>
</template>
<script>
// special component just for BR
import { mapState } from "vuex";
import { post } from "../../tools/request";
import { SUPPORT_COUNTRY_CONFIG } from "../../tools/constant";
import { showAlertDialog, showLoadingToast } from "../../tools/Tip";
export default {
  props: ["formItem", "idx"],
  methods: {
    // goLink() {
    //   let url =
    //     "https://page.99taxis.mobi/pay_intl_driver/card99_progress_v2/card99_progress_v2.html";
    //   if (this.defaultPayMethod.bankInfo) {
    //     url =
    //       "https://page.99taxis.mobi/pay_intl_driver/bank_account/bank_account.html";
    //   }
    //   let up = new URLSearchParams(location.search);
    //   let ticket = this._ticket || up.get("ticket") || up.get("token");
    //   let lang = up.get("lang"),
    //     l = up.get("location_country"),
    //     utc_offset = up.get("utc_offset");
    //   lang = SUPPORT_COUNTRY_CONFIG[l]["lang"];
    //   let href = location.href.replace(/\#.*/g, "");
    //   let redirect = encodeURIComponent(href);
    //   url = `${url}?redirect=${redirect}&ticket=${ticket}&lang=${lang}&utc_offset=${utc_offset}&entrytype=1`;
    //   location.href = url;
    // },
    goLink() {
      showLoadingToast(this);
      let up = new URLSearchParams(location.search);
      let ticket = this._ticket || up.get("ticket") || up.get("token");
      let l = up.get("location_country"),
        utc_offset = up.get("utc_offset");
      let lang = SUPPORT_COUNTRY_CONFIG[l]["lang"]
      let href = location.href.replace(/\#.*/g, "");
      let redirect = encodeURIComponent(href);
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      // 之前的是否绑卡逻辑移到后端去了, 跳转链接由后端控制
      post(process.env.GET_BANKINFO_BR, up)
        .then(data => {
          let jump_link = data.jump_link;
          let query = `redirect=${redirect}&ticket=${ticket}&lang=${lang}&utc_offset=${utc_offset}&entrytype=1&show_apply_card=true`
          if (jump_link.indexOf("?") > -1) {
            jump_link = `${jump_link}&${query}`;
          } else {
            jump_link = `${jump_link}?${query}`;
          }
          location.href = jump_link;
        })
        .catch(err => {
          showAlertDialog(this, err.errmsg);
        })
        .finally(() => {
          this.toast.hide();
        });
    },
    getPageConfig() {
      showLoadingToast(this);
      let up = new URLSearchParams(location.search);
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      post(process.env.GET_BANKINFO_BR, up)
        .then(data => {
          // 接口没有这三个字段了, 加个兜底
          this.address = data.address || {};
          this.bankInfo = data.bankInfo || { citi_para: {}, external_account: {} };
          this.defaultPayMethod = data.defaultPayMethod || { address: 0, bankInfo: 0 };
        })
        .catch(err => {
          showAlertDialog(this);
        })
        .finally(() => {
          this.toast.hide();
        });
    }
  },
  computed: {
    ...mapState(["_ticket"]),
    title() {
      if (this.defaultPayMethod.address) {
        return "Cartão 99";
      } else if (this.defaultPayMethod.bankInfo) {
        return "Conta bancária";
      }
      return this.formItem.title;
    },
    desc() {
      if (this.defaultPayMethod.address) {
        return "Informe um endereço válido para enviarmos o seu Cartão 99.";
      } else if (this.defaultPayMethod.bankInfo) {
        return "Indique uma conta bancária válida para receber seus ganhos";
      }
      return this.formItem.desc;
    },
    input_title() {
      if (this.defaultPayMethod.address) {
        return "Cartão 99";
      } else if (this.defaultPayMethod.bankInfo) {
        return "Conta bancária";
      }
      return this.formItem.input_title;
    },
    payment99CardAddress() {
      let res = "";
      let {
        streetName,
        neighborhood,
        city,
        state,
        zipCode,
        complement,
        addressnum
      } = this.address;
      complement && (res += `${complement},`);
      streetName && (res += `${streetName},`);
      addressnum && (res += `${addressnum},`);
      neighborhood && (res += `${neighborhood},`);
      city && (res += `${city},`);
      state && (res += `${state},`);
      res = res.replace(/,$/, "");
      return res;
    }
  },
  data() {
    return {
      defaultPayMethod: { address: 0, bankInfo: 0 },
      bankInfo: { citi_para: {}, external_account: {} },
      address: {}
    };
  },
  mounted() {
    if (process.env.NODE_ENV !== 'development') {
      this.getPageConfig();
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 0;
  margin-bottom: 0.1rem;
  font-size: 0.36rem;
  color: #414141;
}
.banner {
  padding-left: 0.4rem;
  padding-right: 0.36rem;
}
.title {
  padding-top: 0.32rem;
  font-size: 0.5rem;
  font-weight: 900;
  color: #333;
}
.desc {
  padding: 0.112rem 0 0.16rem 0;
  font-size: 0.28rem;
  color: #7e7e80;
}
.bank-info {
  padding-left: 0.4rem;
  padding-right: 0.36rem;
  background: #fff;
  .link-tip {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 1.4rem;
  }
}

ul {
  font-size: 0.32rem;
  line-height: 0.32rem;
  padding-bottom: 0.32rem;
  li {
    margin-bottom: 0.32rem;
  }
  .left {
    display: inline-block;
    min-width: 1.4rem;
    color: #666;
    letter-spacing: 0.01rem;
  }
  .right {
    font-weight: 600;
    color: #333;
    padding-left: 0.16rem;
  }

  .digit {
    color: #666;
    min-width: 1.696rem;
    float: right;
  }
}
.address-info li {
  display: flex;
  .label {
    min-width: 1.43rem;
    color: #666;
    letter-spacing: 0.01rem;
  }
  .txt {
    font-weight: 600;
    color: #333;
    margin-left: 0.35rem;
  }
}
</style>
